import React from 'react';
import styled from 'styled-components';
import { getPartner } from 'packages/smart-home-support/partner';
import Copyright from '../Copyright';
import LegalLinks from '../LegalLinks';
import { FooterProps } from '../models';
import { useTweekValue } from 'react-tweek';

const s = {
  Container: styled.div`
    background: #000;
    color: #fff;
    padding: 0 25px;
    padding-top: 20px;
    padding-bottom: 40px;
  `,
  Inner: styled.div`
    max-width: 1440px;
    margin: 0 auto;
  `,
  Heading: styled.div`
    font-size: 16px;
    margin-bottom: 26px;
  `,
  Disclaimer: styled.div`
    font-size: 14px;
    margin: 31px 0px;
  `,
  Legal: styled.div`
    font-size: 11px;
  `,
};

const { helpNumber } = getPartner();

const refundPageList: string[] = ['refund-guide', 'warranty-selection'];

const defaultFooterDisclaimer: string =
  'The Asurion® trademark and logo are the property of Asurion, LLC. Apple® and AppleCare® are the trademarks of Apple Inc. All other trademarks are the property of their respective owners. Asurion is not affiliated with, sponsored by, or endorsed by Apple or any of the respective owners of the other trademarks appearing herein.';

const AuthenticatedFooter: React.FC<FooterProps> = ({ pathname }) => {
  const footerDisclaimer: string = useTweekValue(
    'soluto_home_web/smart_home_support/pages/refunds/footer_disclaimer',
    defaultFooterDisclaimer
  );

  return (
    <s.Container>
      <s.Inner>
        {refundPageList.some((p) => pathname.includes(p)) && <s.Disclaimer>{footerDisclaimer}</s.Disclaimer>}
        <s.Heading>
          Need help? Call us. <strong>{helpNumber}</strong>
        </s.Heading>
        <s.Legal>
          <Copyright />
          <br />
          <br />
          <LegalLinks />
        </s.Legal>
      </s.Inner>
    </s.Container>
  );
};

export default AuthenticatedFooter;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/types/AuthenticatedFooter.tsx